module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ECONOMICS-e5505bf81bc74eff26f4a09f5dc012e6.png";